import React, { useState, useEffect, createContext, useContext, useRef } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

// Pages
import Mainpage from "./pages/Mainpage";
import CategoryPage from "./pages/CategoryPage";
import ProductPage from "./pages/ProductPage";
import Login from "./pages/Login";
import Cart from "./pages/Cart.jsx";  // أضف .jsx
import Checkout from "./pages/Checkout.jsx";  // أضف .jsx
import Profile from "./pages/Profile";
import Dashboard from "./pages/Dashboard";
import CustomCategory from "./pages/CustomCategory";
import Wishlist from "./pages/Wishlist";
import OrderDone from "./pages/OrderDone.jsx";
// Utils
import ProtectedRoute from "./ProtectedRoute";
import { db } from "./firebase/firebaseconfig";
import ScrollToTop from "./Components/ScrollToTop.jsx";

// Firestore
import { collection, onSnapshot, getDocs, setDoc, doc } from "firebase/firestore";

// Components
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import logo from "./Assets/logo.png";

// ================= CONTEXT =================
const ProductsGlobalContext = createContext();
export const useGlobal = () => useContext(ProductsGlobalContext);

// ================= APP =================
export default function App() {
  const [products, setProducts] = useState([]);
  const [banners, setBanners] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // ====== GLOBAL NOTIFICATION ======
  const [notification, setNotification] = useState(null);
  const showNotification = (message) => {
    setNotification(message);
    setTimeout(() => setNotification(null), 2000);
  };



  // -------- LOAD DATA WITH REAL-TIME UPDATES (cache-first) --------
  useEffect(() => {
    let unsubProducts = () => {};
    let unsubBanners = () => {};
    let unsubCoupons = () => {};

    (async () => {
      // Try cache-first quick reads
      try {
        const ps = await getDocs(collection(db, "Products"), { source: "cache" });
        if (!ps.empty) {
          setProducts(ps.docs.map(d => ({ id: d.id, ...d.data() })));
          markLoaded("products");
        }
      } catch (e) {
        // cache miss or persistence not enabled yet
      }

      try {
        const bs = await getDocs(collection(db, "Banners"), { source: "cache" });
        if (!bs.empty) {
          setBanners(bs.docs.map(d => ({ id: d.id, ...d.data() })));
          markLoaded("banners");
        }
      } catch (e) {}

      try {
        const cs = await getDocs(collection(db, "Coupons"), { source: "cache" });
        if (!cs.empty) {
          setCoupons(cs.docs.map(d => ({ id: d.id, ...d.data() })));
          markLoaded("coupons");
        }
      } catch (e) {}

      // Attach realtime listeners after attempting cache reads
      unsubProducts = onSnapshot(
        collection(db, "Products"),
        (snapshot) => {
          setProducts(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
          markLoaded("products");
        }
      );

      unsubBanners = onSnapshot(
        collection(db, "Banners"),
        (snapshot) => {
          setBanners(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
          markLoaded("banners");
        }
      );

      unsubCoupons = onSnapshot(
        collection(db, "Coupons"),
        (snapshot) => {
          setCoupons(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
          markLoaded("coupons");
        }
      );
    })();

    // Cleanup listeners
    return () => {
      try { unsubProducts(); } catch (e) {}
      try { unsubBanners(); } catch (e) {}
      try { unsubCoupons(); } catch (e) {}
    };
  }, []);

  // Track initial snapshot arrival for each collection so we hide the loader only after all have fired
  const _initialLoaded = useRef({ products: false, banners: false, coupons: false });
  function markLoaded(key) {
    _initialLoaded.current[key] = true;
    const all = Object.values(_initialLoaded.current).every(Boolean);
    if (all) setLoading(false);
  }

  // -------- LOCK SCROLL WHILE LOADING --------
  useEffect(() => {
    document.body.style.overflow = loading ? "hidden" : "auto";
  }, [loading]);

  return (
    <ProductsGlobalContext.Provider value={{ products, banners, coupons, showNotification }}>
      <div className="app-shell">
         <ScrollToTop /> 
          <div className={`startinganimation ${loading ? 'active' : ''}`}>
            <div className={`imgcontainer ${loading ? 'active' : ''}`}>
              <img src={logo} alt="Gedar Logo" />
            </div>
          </div>
        {!location.pathname.includes("/dashboard") && <Header />}
        {/* global toast */}
        {notification && (
          <div
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              backgroundColor: "#28a745",
              color: "white",
              padding: "15px 20px",
              borderRadius: "5px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
              zIndex: 9999,
              animation: "slideIn 0.3s ease-in-out",
            }}
          >
            {notification}
          </div>
        )}
        <Routes>
        {/* Home */}
        <Route path="/" element={<Mainpage />} />

        {/* Category */}
        <Route path="/category/:name" element={<CategoryPage />} />
        <Route path="/category/:name/:subcategory" element={<CategoryPage />} />
        <Route path="/custom" element={<CustomCategory />} />

        {/* Custom Orders */}
        <Route path="/custom-sticker" element={<CustomCategory />} />
        <Route path="/custom-frame" element={<CustomCategory />} />

        {/* Auth & Cart */}
        <Route path="/login" element={<Login />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/OrderDone" element={<OrderDone />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/wishlist" element={<Wishlist />} />


        {/* Dashboard */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute adminOnly={true}>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* Product Pages */}
        <Route path="/products/:slug" element={<ProductPage />} />
        </Routes>
{!location.pathname.includes("/Dashboard") && <Footer />}
      </div>
    </ProductsGlobalContext.Provider>
  );
}
